/* eslint-disable */
import React from "react";
import { ProfessionalBenefits } from "./partials";

const ProductManager: React.FC = () => (
  <div className="container page-container">
    <div className="card">
      <h2 style={{ marginBottom: 20, textAlign: "center" }}>Head of Sales - Denver, CO</h2>

      <h4>About Haven Connect</h4>
      <p style={{ fontSize: 15 }}>
        Haven Connect transforms the affordable housing industry by streamlining the application
        process for residents and property managers. Haven Connect uses automation and a deep
        understanding of the regulatory challenges for affordable housing to get low-income
        Americans into units faster {"&"} at a fraction of the cost.
      </p>

      <h4 style={{ marginTop: 40 }}>About You</h4>
      <p style={{ fontSize: 15 }}>
        You care deeply about both improving the lives of Americans with low income and building
        a real, profitable business. You are a leader-coach who shows by doing and whose
        strengths embody equal parts strategy and execution. With multiple years of saas
        experience, you are a veteran sales executive who knows how to build a team, strategy,
        and process from the ground up. You are diplomatic and committed to transparent
        communication. You thrive in an atmosphere where the intern’s ideas are given as much
        respect at the executive management. The spirit of the entrepreneur is strong in
        you---you take ownership of your team and projects and are driven by a need to leave
        things better than you found them.
      </p>

      <h4 style={{ marginTop: 40 }}>Role & Responsibilities</h4>
      <p style={{ fontSize: 15 }}>
        <p>
          We are looking for a stellar Head of Sales who will be responsible for leading Haven
          Connect’s Sales Team. As the sales leader, you will collaborate to develop the sales
          strategy and drive key initiatives to achieve sales objectives. This position reports
          to the CEO.
        </p>
        <li>
          Hire, train, ramp, and manage a team of Account Executives responsible for new and
          expansion bookings.
        </li>
        <li>
          Develop and manage Account Executives on productivity metrics such as deal size, win
          rate, and forecast accuracy.
        </li>
        <li>
          Assist Account Executives with contract negotiations & final close, conducting client
          presentations, writing proposals, presenting capability studies to clients.
        </li>
        <li>Achieve annual bookings quota with monthly and quarterly targets.</li>
        <li>
          Coach Account Executives in building executive relationships and shepherding deals
          through a well defined, proactive sales process.{" "}
        </li>
        <li>
          Develop and shape the direction of the go-to-market strategy and execution. Coach
          direct reports re: strategies to drive closure.
        </li>
        <li>
          Be a key business owner within Haven Connect and work collaboratively with Marketing,
          Product and Success to build targeted messaging and collateral, and mapping a customer
          journey.
        </li>
        <li>
          Perform weekly forecasting and documentation using Salesforce.com & Outreach.io,
          ensuring KPIs are being met.
        </li>
      </p>

      <h4 style={{ marginTop: 40 }}>Qualifications</h4>
      <p style={{ fontSize: 15 }}>
        <li>
          You have managed a high performing Account Executive team for a B2B Saas company for
          3-5 years
        </li>
        <li>You possess over 7 years of overall Enterprise sales experience</li>
        <li>You have experience setting quotas and managing people against those quotas</li>
        <li>
          You are a leader-coach who leads by example and inspires through positive
          reinforcement. Has the vision and aptitude to grow the sales team, with the
          flexibility to work with the changing sales process and structure.
        </li>
        <li>
          Fluency building relationships, managing complex sales processes with multiple
          stakeholders, and negotiations with pricing based on business value, legal and
          procurement
        </li>
        <li>
          You have demonstrated a successful track record as an individual contributor and can
          share relevant and complex closing experience with a growing team
        </li>
        <li>
          You understand and embrace the challenges of a post-seed stage technology company
        </li>
        <li>Experience selling to C-suite, especially operations executives </li>
        <li>
          Experience and relationships in residential real estate/property management industry
          is a plus
        </li>
        <li>
          Firm understanding of Salesforce and Outreach; proficiency in G-suite and Office tools
        </li>
        <li>
          Experience with marketing technology, website optimization and A/B testing tools is a
          helpful advantage
        </li>
        <li>
          Excellent interpersonal and communication skills, presentation and writing skills
        </li>
      </p>

      <ProfessionalBenefits />

      <p style={{ fontSize: 15 }}>
        Please email resume or LinkedIn profile to{" "}
        <a href="mailto:hiring@havenconnect.com">hiring@havenconnect.com</a>
      </p>
    </div>
  </div>
);

export default ProductManager;
